import io from 'socket.io-client';
import { setSocketConnection } from './redux/actions/index';

export const openSocketConnection = (dispatch) => {
    let socket = io.connect("https://recruitingmonk-v2.azurewebsites.net/socket");
    dispatch(setSocketConnection(socket));
}